import React, { memo } from 'react';

import Popup from '../../helpers/Popup';
import Button from '../../helpers/Button';

import style from './style.module.css';

const MailingLogPopupComponent = ({ error, hasError, html, onClose }) => {
  const header = 'Mail Log';

  const srcDoc = hasError ? error : html;

  const footer = (
    <Button onClick={onClose} type="button">
      Close
    </Button>
  );

  return (
    <Popup footer={footer} header={header} id="mailingLogPopup">
      <div className="row">
        <div className="col-sm-12">
          <iframe className={style.preview} sandbox="allow-same-origin allow-scripts" srcDoc={srcDoc} title="content" />
        </div>
      </div>
    </Popup>
  );
};

export const MailingLogPopup = memo(MailingLogPopupComponent);
